// ../internal/src/components/ad-block-detect/ad-block-detect.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var AD_BLOCK_DETECTED_EVENT = new SystemEvent(SystemEventLevel.INFO, "AD_BLOCK_DETECTED");
var CollapsedComponent = function () {
  var events = useLoggerEvents({
    AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
  });
  events.AD_BLOCK_DETECTED_EVENT.log({
    message: "collapsing"
  });
  return null;
};
var UncollapsedWrappedComponent = function (props) {
  var children = props.children;
  var events = useLoggerEvents({
    AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
  });
  events.AD_BLOCK_DETECTED_EVENT.log({
    message: "not collapsing"
  });
  return /* @__PURE__ */React.createElement(React.Fragment, null, children);
};
function withAdBlockDetect(WrapperComponent) {
  var WithAdBlockDetectHOC = function (componentProps) {
    var collapseWhenAdBlockDetected = componentProps.collapseWhenAdBlockDetected,
      adBlockCollapseExperiment = componentProps.adBlockCollapseExperiment;
    var UncollapsedComponent = /* @__PURE__ */React.createElement(UncollapsedWrappedComponent, null, /* @__PURE__ */React.createElement(WrapperComponent, _object_spread({}, componentProps)));
    var renderVariant = function () {
      if (adBlockCollapseExperiment === "PG_Acceptable_Ads_Enablement") {
        return /* @__PURE__ */React.createElement(Experiment, {
          name: "PG_Acceptable_Ads_Enablement"
        }, /* @__PURE__ */React.createElement(ExperimentControl, null, /* @__PURE__ */React.createElement(CollapsedComponent, null)), /* @__PURE__ */React.createElement(ExperimentVariant, {
          bucket: 1
        }, UncollapsedComponent));
      }
      if (adBlockCollapseExperiment === "Acceptable_Ads_Component_Enablement") {
        return UncollapsedComponent;
      }
      return /* @__PURE__ */React.createElement(CollapsedComponent, null);
    };
    if (typeof window !== "undefined") {
      var _window_meso;
      window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
      if (!window.meso.adblock || window.meso.adblock.enabled) {
        if (adBlockCollapseExperiment) {
          return /* @__PURE__ */React.createElement(Experiment, {
            name: "Acceptable_Ads_Component_Enablement"
          }, /* @__PURE__ */React.createElement(ExperimentControl, null, /* @__PURE__ */React.createElement(CollapsedComponent, null)), /* @__PURE__ */React.createElement(ExperimentVariant, {
            bucket: 1
          }, renderVariant()));
        }
        if (collapseWhenAdBlockDetected === false) {
          return UncollapsedComponent;
        }
        return /* @__PURE__ */React.createElement(CollapsedComponent, null);
      }
    }
    return /* @__PURE__ */React.createElement(WrapperComponent, _object_spread({}, componentProps));
  };
  WithAdBlockDetectHOC.displayName = "WithAdBlockDetectHOC";
  return WithAdBlockDetectHOC;
}
// src/components/ad-block-detect-wrapper/ad-block-detect-wrapper.tsx
var AdBlockDetectWrapper = function (WrapperComponent) {
  return withAdBlockDetect(WrapperComponent);
};
AdBlockDetectWrapper.displayName = "sharedui-AdBlockDetectWrapper";
// src/components/ad-blocker-aware/ad-blocker-aware.tsx
import React2 from "react";
import { useExperiment } from "@shared-ui/experiment-context";
var GetIABAcceptableAdsEnablementBucket = function () {
  return useExperiment("IAB_Acceptable_Ads_Enablement", true).exposure.bucket;
};
var GetMarqueeAcceptableAdsEnablementBucket = function () {
  return useExperiment("Marquee_Acceptable_Ads_Enablement").exposure.bucket;
};
var AdBlockerAware = function (props) {
  var _window_meso_adblock, _window_meso, _localStorage_getItem;
  var _props_isSponsored = props.isSponsored,
    isSponsored = _props_isSponsored === void 0 ? true : _props_isSponsored,
    callback = props.callback,
    renderCallback = props.renderCallback,
    children = props.children,
    _props_fallbackComponent = props.fallbackComponent,
    fallbackComponent = _props_fallbackComponent === void 0 ? null : _props_fallbackComponent,
    _props_adBlockExperiment = props.adBlockExperiment,
    adBlockExperiment = _props_adBlockExperiment === void 0 ? "" : _props_adBlockExperiment;
  var isClientSideRendering = function () {
    return typeof window !== "undefined";
  };
  var isAdBlockEnabled = isClientSideRendering() && ((_window_meso = window.meso) === null || _window_meso === void 0 ? void 0 : (_window_meso_adblock = _window_meso.adblock) === null || _window_meso_adblock === void 0 ? void 0 : _window_meso_adblock.enabled) !== false;
  var isAcceptableAdsEnabled = isClientSideRendering() && ((_localStorage_getItem = localStorage.getItem("eg_adblock")) === null || _localStorage_getItem === void 0 ? void 0 : _localStorage_getItem.split("|").includes("aaa=1"));
  var adBlockExperimentBucket = 0;
  if (adBlockExperiment === "IAB_Acceptable_Ads_Enablement" /* IAB_Acceptable_Ads_Enablement */ && isAcceptableAdsEnabled) {
    adBlockExperimentBucket = GetIABAcceptableAdsEnablementBucket();
  }
  if (adBlockExperiment === "Marquee_Acceptable_Ads_Enablement" /* Marquee_Acceptable_Ads_Enablement */) {
    adBlockExperimentBucket = GetMarqueeAcceptableAdsEnablementBucket();
  }
  var acceptableAdsEnablement = useExperiment("Acceptable_Ads_Component_Enablement").exposure.bucket;
  var isExperimentsEnabled = acceptableAdsEnablement === 1 && adBlockExperimentBucket === 1;
  if (isSponsored && isAdBlockEnabled && !isExperimentsEnabled) {
    renderCallback === null || renderCallback === void 0 ? void 0 : renderCallback(false);
    return /* @__PURE__ */React2.createElement(React2.Fragment, null, fallbackComponent);
  }
  callback === null || callback === void 0 ? void 0 : callback();
  renderCallback === null || renderCallback === void 0 ? void 0 : renderCallback(true);
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, children);
};
AdBlockerAware.displayName = "sharedui-AdBlockerAware";
export { AdBlockDetectWrapper, AdBlockerAware };